import { DeleteIcon } from "../../assets/icons/icons";

export default function DeleteSpecificMedia({ className, ...props }) {
  return (
    <div
      {...props}
      className={`absolute cursor-pointer opacity-0 transition-opacity group-hover:opacity-100 ${className}`}
    >
      <DeleteIcon />
    </div>
  );
}
